import { useQuery } from '@tanstack/react-query'
import { fetchDeals, fetchDims, fetchMe } from './api'

// Deals are the heavy payload — cache for 5 min, refetch on window focus off.
export function useDeals() {
  return useQuery({
    queryKey: ['deals'],
    queryFn:  ({ signal }) => fetchDeals({ signal }),
    staleTime:            5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}

export function useDims() {
  return useQuery({
    queryKey: ['dims'],
    queryFn:  ({ signal }) => fetchDims({ signal }),
    staleTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn:  fetchMe,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
